import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getNotification,
  updateNotificationAction,
} from "../../redux/actions/notificationAction";
import LoadingIndicator from "../../components/loadingIndicator";

const Notification = () => {
  const location = useLocation();
  const { pathname } = location;
  const notificationId = pathname.split("/").pop();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState({});
  const navigate = useNavigate();

  const initialFormState = {
    title: "",
    type: "",
    msg: "",
  };
  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    const fetchNotificationDetails = async () => {
      try {
        const response = await dispatch(getNotification(notificationId));
        if (response && response.success) {
          const notificationDetails = response.req_notification; // Accessing req_notification from the response
          setFormData({
            title: notificationDetails.title,
            type: notificationDetails.type,
            msg: notificationDetails.msg,
          });
        } else {
          console.log("Failed to fetch notification details");
          toast.error("Failed to fetch notification details");
        }
      } catch (error) {
        console.log("Error fetching notification details", error);
        toast.error("Error fetching notification details");
      }
    };

    fetchNotificationDetails();
  }, [notificationId, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      // await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await validationSchema.validate(formData, { abortEarly: false });
      setLoading(true); // Start loading
      const updatedFormData = {
        ...formData,
        // adminId: adminId,
      };

      console.log("Formdata", updatedFormData);
      const response = await dispatch(
        updateNotificationAction(notificationId, updatedFormData)
      );

      if (response) {
        toast.success("Notification added successufully");
        navigate("/notification");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to add Notification");
      }
    } catch (validationErrors) {
      // Handle validation errors
      const errors = {};
      if (validationErrors.inner) {
        validationErrors.inner.forEach((validationError) => {
          errors[validationError.path] = validationError.message;
        });
      }
      setErr(errors);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="EDIT NOTIFICATION" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.title}
            margin="normal"
          />{" "}
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}
          {/* TYPE */}
          <TextField
            label="Type"
            name="type"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.type}
            margin="normal"
          />{" "}
          {err.type && (
            <Grid item>
              <Typography color="error">{err.type}</Typography>
            </Grid>
          )}{" "}
          {/* MESSAGE */}
          <TextField
            label="Message"
            name="msg"
            onBlur={handleBlur}
            onChange={handleChange}
            value={formData.msg}
            margin="normal"
          />{" "}
          {err.msg && (
            <Grid item>
              <Typography color="error">{err.msg}</Typography>
            </Grid>
          )}{" "}
          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              disabled={loading}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
      {loading && <LoadingIndicator />}
    </Box>
  );
};
export default Notification;
